import common from './common';
import onboard from './onboard';
import party from './party';
import payment from './payment';
import policies from './policies';
import quotes from './quotes';

export { common, onboard, payment, quotes, policies, party };
